import axios from 'axios'
import qs from 'qs'


let mediaVideoTracks = [], facingModeArr = [{"value": "user", "flag": true}, {"value": "environment", "flag": true}],
    _this;
export let photoConfig = {
    name: "PhotoGraph",
    data() {
        return {
            videoEle: '',
            isOpenMedia: true
        }
    },
    mounted() {
        _this = this
        this.videoEle = document.getElementById("videoArea")
    },
    methods: {
        openMedia(facingMode) {
            // 摄像头设置
            let video = {
                // width: {min: 800, ideal: 1020, max: 1200},
                // height: {min: 600, ideal: 960, max: 1024},
                width: 800,
                height: 600
                // facingMode: "user"      // 前置或者后置摄像头 "user"  "environment"
            }
            if (facingMode) {
                video.facingMode = facingMode;
            }
            let constraints = {
                video: video,
                // audio: true
            };
            if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                // 获取媒体信息
                window.navigator.mediaDevices.getUserMedia(constraints).then(function (mediaStream) {
                    mediaVideoTracks = mediaStream.getVideoTracks();
                    if (mediaVideoTracks.length === 0) {
                        _this.openMediaFail(facingMode);
                        return;
                    }
                    // 旧的浏览器可能没有srcObject
                    if ("srcObject" in _this.videoEle) {
                        _this.videoEle.srcObject = mediaStream;
                    } else {
                        // 防止在新的浏览器里使用它，应为它已经不再支持了
                        _this.videoEle.src = window.URL.createObjectURL(mediaStream);
                    }
                    _this.videoPlay();  // 开始播放
                }).catch(function (err) {
                    _this.openMediaFail(facingMode);
                })
            } else {
                _this.openMediaFail(facingMode);
            }
        },
        openMediaFail(facingMode) {
            // 判断是否有值  若有值将改值的记录标识flag 设为false
            if (facingMode) {
                for (let i = 0; i < facingModeArr.length; i++) {
                    let obj = facingModeArr[i];
                    if (facingMode === obj.value) {
                        obj.flag = false;
                    }
                }
            }
            // 循环数组 取标识flag 为true的记录 并重新打开摄像头
            for (let i = 0; i < facingModeArr.length; i++) {
                let obj = facingModeArr[i];
                if (obj.flag) {
                    this.openMedia(obj.value)
                    return;
                }
            }
            // 若数组 标识flag 全为false 证明打开摄像头失败
            alert("摄像头打开失败，请检查摄像头是否正常。摄像头是否被其他应用占用。")
            this.isOpenMedia = false
        },
        closeVideo() {
            this.videoPause();
            let len = mediaVideoTracks.length;
            if (len > 0) {
                for (let i = 0; i < len; i++) {
                    let videoTrack = mediaVideoTracks[i];
                    videoTrack.stop();
                }
            }
        },
        uploadAliPhoto() { // 图片上传至阿里云服务器
            this.isUploadAliPhoto = true
            if (!this.isOpenMedia) {
                alert("摄像异常，无法拍照，请检查摄像头。")
                setTimeout(() => {
                    this.isUploadAliPhoto = false
                }, 1000)
                return false;
            }

            let imgBase64 = this.capturePhoto();

            this.getPhoto(imgBase64).then(res => {
                setTimeout(() => {
                    this.isUploadAliPhoto = false
                    if (!res.data.url) return this.$message({
                        type: 'error',
                        message: '拍照失败，请重试'
                    });
                    this.imageUrl = res.data.url
                    this.uploadPhoto()
                }, 1000)
            })

        },
        uploadPhoto() { // 上传至服务器
            this.isUploadPhoto = true

            if (!this.imageUrl) {
                alert('请拍照确认之后在上传图片!');
                setTimeout(() => {
                    this.isUploadPhoto = false
                }, 1000)
                return false;
            }

            let SectionObj = this.currentSectionObj

            if(!SectionObj.id) {
                SectionObj = this.getSectionNext(this.sectionList, this.currentSectionId)
            }

            this.$post(this.$API.SAVE_MEMBER_VEDIO_PHOTO_PC, {
                photo: this.imageUrl,
                token: localStorage.getItem('token'),
                'studySection.id': this.currenStudySectionId,
                pxbId: SectionObj.pxbId,
                pxbName: SectionObj.pxbName,
                memberSectionId: SectionObj.id
            }).then(r => {

                if (r.code === 202) return this.$message({
                    type: 'error',
                    message: r.msg
                });

                this.$message({
                    type: 'success',
                    message: `图片上传成功`
                });

                // 清除二维码
                if(this.$refs.qrCodeDiv) this.clickQrCodeBack();

                // 清除后太照片
                this.clearAdminPhoto()

                setTimeout(() => {
                    this.isShowQrCode = false
                    this.isUploadPhoto = false
                    this.cameraUrl = this.imageUrl
                }, 1200)

                // if (!this.isVideoEnd)
                //     this.$emit('changeStart');
                // else
                //     this.$emit('changeEnd');
                // this.closeVideo();
            })
        },
// 视频区域播放
        videoPlay() {
            if (this.videoEle) {
                this.videoEle.play();
            }
        },
// 暂停视频区域
        videoPause() {
            if (this.videoEle) {
                this.videoEle.pause();
            }
        },
        capturePhoto: function () { // 捕获照片
            let that = this;
            if (!mediaVideoTracks || mediaVideoTracks.length === 0) {
                return alert("摄像头设备有误。");
            }

            // 获取视频区域模块高度
            let videoWidth = that.videoEle.videoWidth;
            let videoHeight = that.videoEle.videoHeight;
            let canvasEle = document.createElement('canvas');
            let imgBase64;


            if (videoWidth && videoHeight) {
                canvasEle.width = videoWidth;
                canvasEle.height = videoHeight;
                canvasEle.getContext('2d').drawImage(that.videoEle, 0, 0, videoWidth, videoHeight);
                imgBase64 = canvasEle.toDataURL('image/jpeg');
            } else {
                canvasEle.getContext('2d').drawImage(that.videoEle, 0, 0, canvasEle.width, canvasEle.height);
                imgBase64 = canvasEle.toDataURL('image/jpeg');
            }
            return imgBase64
        },
        //  获取图片
        getPhoto(imgBase64) {
            axios.defaults.withCredentials = false
            return axios({
                method: 'post',
                url: 'https://oss.yyadmin.cn/oss/image/uploadBase64',
                data: qs.stringify({
                    "imgBase64": imgBase64,
                    "diskName": 'video'
                }),
                jsonp: 'onBack',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                },
            }).then(
                (response) => {
                    return response
                }
            ).then(
                (res) => {
                    return res
                }
            )
        }
    }
}
